import React from "react";
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
// repush code for test
export const replaceKeywordWithLink = (text, keywordOrKeywords, url, target = "_blank", rel = "noreferrer", linkType = "a") => {
  if (!keywordOrKeywords) return text;

  let keywordsArray = [];

  if (Array.isArray(keywordOrKeywords)) {
    keywordsArray = keywordOrKeywords;
  } else if (typeof keywordOrKeywords === "string" && url) {
    keywordsArray = [{ keyword: keywordOrKeywords, embeddedLink: url }];
  } else {
    return text;
  }

  const pattern = keywordsArray.map(({ keyword }) => `(${keyword})`).join("|");
  const regex = new RegExp(pattern, "gi");
  return text.split(regex).map((part, index) => {
    if (part && typeof part === "string") {
      const matchedKeyword = keywordsArray.find(({ keyword }) => keyword.toLowerCase() === part.toLowerCase());
      return matchedKeyword ? (
        linkType === "a" ? (
          <Link
            key={`${matchedKeyword.keyword}-${index}`}
            target={target}
            rel={rel}
            href={matchedKeyword.embeddedLink}
            style={{ color: matchedKeyword.linkColor ? matchedKeyword.linkColor : "inherit" }}
          >
            {part}
          </Link>
        ) : (
          <RouterLink
            key={`${matchedKeyword.keyword}-${index}`}
            target={target}
            rel={rel}
            to={matchedKeyword.embeddedLink}
            style={{ color: matchedKeyword.linkColor ? matchedKeyword.linkColor : "inherit" }}
          >
            {part}
          </RouterLink>
        )
      ) : (
        part
      );
    }
    return part;
  });
};
